package com.fireavert.devices.data_models.data_model

import kotlinx.serialization.Serializable

@Serializable
enum class PowerStatus {
    ON,
    OFF,
    UNKNOWN
}